import httpClient from '@/api/http-client';

const endpoint = 'api/audits';

const changeHistoryService = {
  getPage: (params) => httpClient.get(endpoint, { params }),
};

export default changeHistoryService;
